import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Container,Row, Col,CardImg} from 'reactstrap';

class SatisfactionClientPage extends Component {
  constructor(props) {
        super(props);
        this.state = {
            admin : null,
            email : null,
            message : null,
        };
    }
  
  change = e =>{
        this.setState({
            [e.target.id] : e.target.value
        }); 
  };
  submit = e =>{
        e.preventDefault();
        const formData = {
            admin: this.state.admin,
            email: this.state.email,
            message: this.state.message,
        };
        console.log(formData)
    }

  render() {
   

    return (
      <div>
        <Container className="mb-4 section-start">
            <Row>
                <Col xs="12" md="6" lg="6" className="column-start-left">
                    <Row>
                      <Col xs="12" md="7" lg="7" className="aside-start-left">
                          <div className="start-vide mb-2">
                            <CardImg src="/images/logo/star-empty.svg" alt="zone"/>
                            <CardImg src="/images/logo/star-empty.svg" alt="zone"/>
                            <CardImg src="/images/logo/star-empty.svg" alt="zone"/>
                            <CardImg src="/images/logo/star-empty.svg" alt="zone"/>
                             <br/><p>Note moyenne:<span>0/5</span></p>
                          </div>

                         
                      </Col>
                      <Col xs="12" md="5" lg="5">
                        <span className="start-service">0 <br/>Reponse</span>
                      </Col>
                    </Row>
                </Col>
                <Col xs="12" md="6" lg="6" className="column-start-right">
                  <Row>
                    <Col xs="12" md="3" lg="3">
                    </Col>
                    <Col xs="12" md="9" lg="9">
                      <div className="grid">
                          <section>
   
                          </section>
                      </div>
                      <div className="cabinet-client">
                        <h6>100 % de nos clients recommandent notre cabinet</h6>
                      </div>
                    </Col>
                  </Row>
                </Col>
            </Row>
            <Row className="start-block">
                <Col xs="12" md="6" lg="6">
                  <h3>Professionnalisme</h3>
                  <p>Compétences de l’équipe d’accompagnement</p>
                </Col>
                <Col xs="12" md="6" lg="6" className="text-center">
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                </Col>
            </Row>
            <Row className="start-block">
                <Col xs="12" md="6" lg="6">
                  <h3>Disponibilité de l’équipe</h3>
                  <p>Démarrage du bilan, respect des rendez-vous</p>
                </Col>
                <Col xs="12" md="6" lg="6" className="text-center">
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                </Col>
            </Row>
            <Row className="start-block">
                <Col xs="12" md="6" lg="6">
                  <h3>Ouverture</h3>
                  <p>Respect, non-jugement</p>
                </Col>
                <Col xs="12" md="6" lg="6" className="text-center">
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                </Col>
            </Row>
            <Row className="start-block">
                <Col xs="12" md="6" lg="6">
                  <h3>Implication</h3>
                  <p>Capacité d’écoute, disponibilité</p>
                </Col>
                <Col xs="12" md="6" lg="6" className="text-center">
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                </Col>
            </Row>
        </Container>
      </div>
    )
  }
}

function mapStateToProps({clientReducer}) {
  return {
    client: clientReducer,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    // getSatisfactionClientData: bindActionCreators(getSatisfactionClientData, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SatisfactionClientPage);


// WEBPACK FOOTER //
// ./src/components/cms/SatisfactionClientPage.js